import React from 'react';
import BaseModal from "./BaseModal";
import ModalAgreementForm from "../auth/social_channels/ModalAgreementForm";

function TermsAndPrivacyModal(props) {
    return props.modalShown ?
        (
            <BaseModal modalId={"myModal"} modalClass={"modal"} innerDivClass={"modal-content"}>
                <ModalAgreementForm closeModal={props.closeModal} agreementConfirmFunction={props.agreementConfirmFunction}/>
            </BaseModal>
        ) : null;
}

export default TermsAndPrivacyModal;